import React from 'react';
import { Formik } from 'formik';
import { AddResourceFormValues, defaultValues, validationSchema } from './types';
import { ResourceFormFields } from './components/ResourceFormFields';
import './ResourceForm.scss';

interface AddResourceFormProps {
  onSubmit: (values: AddResourceFormValues) => void;
  onCancel: () => void;
}

export const AddResourceForm: React.FC<AddResourceFormProps> = ({ onSubmit, onCancel }) => {
  const handleSubmit = (values: AddResourceFormValues) => {
    onSubmit(values);
  };

  return (
    <div className="resource-form">
      <h2>Add New Resource</h2>
      <Formik
        initialValues={defaultValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        validateOnMount={true}
        validateOnChange={true}
        validateOnBlur={true}
        validateOnSubmit={true}
      >
        <ResourceFormFields onCancel={onCancel} />
      </Formik>
    </div>
  );
};
